import React, { useEffect, useState } from "react";
import { Row, Card, Stack, Col } from "react-bootstrap";
import "./../../App.css";
import ClipLoader from "react-spinners/ClipLoader";
import { useParams } from "react-router-dom";

const override = {
  display: "block",
  margin: "0 auto",
};

const SchadeMeldingen = () => {
  const [schade, setSchade] = useState([]);
  const [loading, setLoading] = useState(false);
  const { apiKey } = useParams();

  const getSchade = async () => {
    setLoading(true);
    const resp = await fetch(
      "api/SchadeMeldingen/GetSchadeMeldingenTenants/" + apiKey
    );
    if (resp.ok) {
      const data = await resp.json();
      setSchade(data);
      setLoading(false);
    } else {
      console.log("error");
    }
  };

  useEffect(() => {
    getSchade();

    const autoR = setInterval(() => {
      getSchade();
    }, 15*60*1000);

    return () => clearInterval(autoR);
  }, []);

  const StatusNumberBg = [
    "danger",
    "warning",
    "success",
    "dark",
    "secondary",
    "info",
  ];
  const CrappyTextFix = ["light", "dark", "light", "light", "dark", "dark"];

  return (
    <>
      {loading ? (
        <div>
          <ClipLoader
            color="#5b36d6"
            loading={loading}
            cssOverride={override}
            speedMultiplier="0.8"
            size={35}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      ) : (
        <Row className="mb-2">
          <Col>
            <Card>
              <Card.Header className="fw-bold text-center fs-4">
                Schademeldingen
              </Card.Header>
              <Card.Body>
                <Stack
                  direction="horizontal"
                  gap={3}
                  className="justify-content-top wrapper"
                >
                  {schade.map((s) => (
                    <Col key={s.id}>
                      <Card
                        border={StatusNumberBg[s.status]}
                        bg={StatusNumberBg[s.status]}
                        text={CrappyTextFix[s.status]}
                        style={{ height: "100%" }}
                      >
                        <Card.Header className="fw-bold text-center fs-5">
                          {s.droppointName}
                        </Card.Header>
                        <Card.Body
                          className="text-dark"
                          style={{
                            backgroundColor: "rgba(255, 255, 255, 0.55)",
                          }}
                        >
                          <Card.Text>
                            <li style={{ listStyleType: "none" }}>
                              <b>Datum:</b> {new Date(s.created).toLocaleDateString('nl-NL')}
                            </li>
                            <li style={{ listStyleType: "none" }}>
                              <b>Fiets:</b> {s.vehicleCode}
                            </li>
                            <li style={{ listStyleType: "none" }}>
                              <b>Beschadigd onderdeel:</b> {s.dutchBikePart}
                            </li>
                          </Card.Text>
                          <hr />
                          <Card.Text>
                            <li style={{ listStyleType: "none" }}>
                              <b>Melding:</b> {s.description === null || s.description === "" ? "-" : s.description}
                            </li>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Stack>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};
export default SchadeMeldingen;
